import styled from 'styled-components';
import { Hero as InnerHero } from '@xingternal/typography';
import { mediaSmallOrTiny, mediaSmallOnly } from '@xingternal/layout-tokens';
import { scale070, scale080 } from '@xingternal/tokens';

export const Hero = styled(InnerHero)`
  display: flex;
  flex-direction: column-reverse;
`;

export const Subtitle = styled.span`
  display: block;
  margin: 0;
  hyphens: auto;
  font-size: ${scale080};
  font-weight: 400;
  width: fit-content;
  @media ${mediaSmallOrTiny} {
    font-size: ${scale070};
  }
  @media ${mediaSmallOnly} {
    line-height: 17px;
  }
`;

export const WhiteSpace = styled.span`
  display: none;
`;
